import EventRenderer from 'components/EventRenderer/EventRenderer';
import * as React from 'react';
import styled from 'styled-components';
import { IEvent } from 'types/events';

interface IProps {
  events: IEvent[];
}

const rows = ['City', 'Country', 'Start Date', 'End Date', 'Level', 'Venue'];

export const EventsTable: React.SFC<IProps> = props => {
  return (
    <Table>
      <HeadRow>
        {rows.map((row, i) => {
          return <Header key={i}>{row}</Header>;
        })}
      </HeadRow>
      {props.events.map((event, i) => (
        <EventRenderer event={event} key={i} />
      ))}
    </Table>
  );
};

const Table = styled.table`
  border-collapse: collapse;
  width: 100%;
`;

const HeadRow = styled.tr``;

const Header = styled.th`
  border-bottom: 2px solid black;
  padding: 10px;
  text-align: left;
`;

export default EventsTable;



// WEBPACK FOOTER //
// ./src/components/EventsTable/EventsTable.tsx